const t = {
  data() {
    return {
      backgroundPosition: "-1000px 0"
    };
  },
  mounted() {
    setInterval(() => {
      this.backgroundPosition = this.backgroundPosition === "-1000px 0" ? "1000px 0" : "-1000px 0";
    }, 3e3);
  }
};
export {
  t as default
};
//# sourceMappingURL=shimmer.vue2.js.map
